// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
// menu actions
export const SET_MENU_BASIS = '@customization/SET_MENU_BASIS';
export const SET_MENU_ACCESS = '@customization/SET_MENU_ACCESS';
export const SET_MENU_BADGE = '@customization/SET_MENU_BADGE';
